export const COLORS = [
  "rgb(90, 103, 216)",
  "rgb(221, 107, 32)",
  "rgb(213, 63, 140)",
  "rgb(236, 201, 75)",
  "rgb(56, 161, 105)",
  "rgb(18, 58, 194)",
  "rgb(213, 242, 117)",
  "rgb(106, 194, 75)",
  "rgb(253, 55, 129)",
  "rgb(19, 209, 192)",
  "rgb(255, 121, 92)",
  "rgb(155, 231, 255)",
  "rgb(255, 188, 77)",
  "rgb(175, 0, 17)",
  "rgb(232, 213, 181)",
  "rgb(126, 57, 0)",
  "rgb(168, 159, 255)",
  "rgb(165, 180, 75)",
  "rgb(186, 30, 169)",
  "rgb(47, 72, 88)"
];
